"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CosmosHandler = void 0;
const encoding_1 = require("@cosmjs/encoding");
const stargate_1 = require("@cosmjs/stargate");
const tx_1 = require("cosmjs-types/cosmwasm/wasm/v1/tx");
const types_1 = require("../../types");
class CosmosHandler {
    async validateBalance({ data, params }) {
        const { signerAddress } = data;
        const signer = data.signer;
        const coin = {
            denom: params.fromToken.address,
            amount: params.fromAmount
        };
        if (!signerAddress) {
            throw new Error("signerAddress not provided");
        }
        const signerCoinBalance = await signer.getBalance(signerAddress, coin.denom);
        const currentBalance = BigInt(signerCoinBalance.amount);
        const transferAmount = BigInt(coin.amount);
        if (transferAmount > currentBalance) {
            throw `Insufficient funds for account: ${signerAddress} on chain ${params.fromChain.chainId}`;
        }
        return true;
    }
    async executeRoute({ data, params }) {
        await this.validateBalance({ data, params });
        const { route } = data;
        const signerAddress = data.signerAddress;
        const signer = data.signer;
        const cosmosMsg = JSON.parse(route.transactionRequest?.data);
        const msgs = [];
        switch (cosmosMsg.msgTypeUrl) {
            case types_1.IBC_TRANSFER_TYPE: {
                msgs.push({
                    typeUrl: cosmosMsg.msgTypeUrl,
                    value: cosmosMsg.msg
                });
                break;
            }
            case types_1.WASM_TYPE: {
                // register execute wasm msg type for signer
                signer.registry.register(types_1.WASM_TYPE, tx_1.MsgExecuteContract);
                const wasmHook = cosmosMsg.msg;
                msgs.push({
                    typeUrl: cosmosMsg.msgTypeUrl,
                    value: {
                        sender: signerAddress,
                        contract: wasmHook.wasm.contract,
                        msg: (0, encoding_1.toUtf8)(JSON.stringify(wasmHook.wasm.msg)),
                        funds: [
                            {
                                denom: params.fromToken.address,
                                amount: route.params.fromAmount
                            }
                        ]
                    }
                });
                break;
            }
            default:
                throw new Error(`Cosmos message ${cosmosMsg.msgTypeUrl} not supported`);
        }
        // simulate tx to estimate gas cost
        const estimatedGas = await signer.simulate(signerAddress, msgs, "");
        const gasMultiplier = Number(route.transactionRequest?.maxFeePerGas) || 1.3;
        const gasPrice = route.transactionRequest?.gasPrice;
        return signer.sign(signerAddress, msgs, (0, stargate_1.calculateFee)(Math.trunc(estimatedGas * gasMultiplier), stargate_1.GasPrice.fromString(gasPrice)), "");
    }
    async getBalances({ addresses, cosmosChains }) {
        const cosmosBalances = [];
        for (const chain of cosmosChains) {
            if (chain.chainType !== types_1.ChainType.COSMOS)
                continue;
            const addressData = addresses.find(address => address.coinType === chain.coinType);
            if (!addressData)
                continue;
            const cosmosAddress = this.deriveCosmosAddress(chain.bech32Config.bech32PrefixAccAddr, addressData.address);
            try {
                const client = await stargate_1.StargateClient.connect(chain.rpc);
                const balances = (await client.getAllBalances(cosmosAddress)) ?? [];
                if (balances.length === 0)
                    continue;
                balances.forEach(balance => {
                    const { amount, denom } = balance;
                    cosmosBalances.push({
                        balance: amount,
                        denom,
                        chainId: String(chain.chainId),
                        decimals: chain.currencies.find(currency => currency.coinDenom === denom)
                            ?.coinDecimals ?? 6
                    });
                });
            }
            catch (error) {
                //
            }
        }
        return cosmosBalances;
    }
    deriveCosmosAddress(chainPrefix, address) {
        return (0, encoding_1.toBech32)(chainPrefix, (0, encoding_1.fromBech32)(address).data);
    }
}
exports.CosmosHandler = CosmosHandler;
//# sourceMappingURL=index.js.map